var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.stfb0{fill-rule:evenodd;clip-rule:evenodd;}\r\n"),React.createElement("path",{"className":"stfb0","d":"M6.2,3h24.7c1.7,0,3.1,1.3,3.1,3v24c0,1.7-1.4,3-3.1,3H6.2c-1.7,0-3.1-1.3-3.1-3V6C3.1,4.3,4.5,3,6.2,3z M6.2,6\r\n\tv24h24.7V6H6.2z M17.2,18H20v9h3.1v-9h3.1v-3h-3.1v-1.5c0-0.8,0.7-1.5,1.5-1.5h1.5V9h-1.5c-2.6,0-4.6,2-4.6,4.5V15h-2.9V18z","key":1})]);
}

Facebook.defaultProps = {"version":"1.1","id":"facebook","x":"0px","y":"0px","viewBox":"0 0 37 36","style":{"enableBackground":"new 0 0 37 36"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
